const i = (t) => {
  navigator.clipboard.writeText(t || "");
}, l = (t) => Array.from(Array(t).keys()), m = (t, a, r) => Math.min(Math.max(t, a), r), y = (t) => new Promise((a) => {
  setTimeout(() => {
    a();
  }, t);
});
function s(...t) {
  const a = (r) => !!(r && typeof r == "object");
  return t.reduce((r, n) => (Object.keys(n).forEach((e) => {
    const c = r[e], o = n[e];
    Array.isArray(c) && Array.isArray(o) ? r[e] = c.concat(...o) : a(c) && a(o) ? r[e] = s(c, o) : r[e] = o;
  }), r), {});
}
export {
  m as clamp,
  i as copyToClipboard,
  l as generateIndexArray,
  s as mergeDeep,
  y as wait
};
